<template>
  <div>
    <!--<router-view></router-view>-->
    <Home />
  </div>
</template>

<script>
    import Home from '../../components/app-layout/Home';
    import StaffDashboard from '../../components/staff/StaffDashboard';
  export default {
    name: 'StaffDashboard',
    components: {
      Home,StaffDashboard
    },
  };
</script>

<style scoped>

</style>
